import React, { useState, useEffect } from "react";
import Button from "sushiweb/Button";
import NoFooterModal from "../../../../Common/NoFooterModal";
import { BottomSectionModal } from "../../../../../constants/assets/containers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UserActions from "../../../../../store/actions/User";
import * as OrderActions from "../../../../../store/actions/Orders";
import { isValNull } from "../../../../../utils";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../../../Common/PaginatedReactDropdown";

const CancelModal = ({ order_id, handleClose, setStatus, cancel, reason_codes }) => {
  
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");

  const handleCommentChange = (e) => {
    setComment(e);
  };

  const handleReasonChange = (key, val) => {
    setReason(val);
  };

  function handleSubmit() {
    if (isValNull(order_id)) {
      setStatus({
        type: "error",
        message: "no order_id present. reload page",
      });
      return;
    }
    if (isValNull(reason)) {
      setStatus({
        type: "error",
        message:
          "reason should be selected",
      });
      return;
    }
    cancel(order_id, { reason_code: String(reason), comment: String(comment) } ).then((r) => {
      if (r === "success") {
        setStatus({
          type: "success",
          message: "succesfully cancelled",
        });
        handleClose();
      }
    });
  }
  return (
    <div>
      <NoFooterModal
        header
        heading="Cancel"
        handleClose={handleClose}
        id="CancelModal"
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="confirm-btn"
              onClick={handleSubmit}
              className="sushi-btn"
              disabled={false}
            >
              Submit
            </Button>
          </BottomSectionModal>
        }
      >
        <PaginatedReactDropdown
            options={reason_codes}
            labelKey="label"
            valueKey="key"
            labelWidth="8%"
            value={reason}
            handleChange={handleReasonChange}
            keyToChange="reason"
            placeholder="Reason"
            showCross={false}
            id="reasonDropdown"
        />
        <Input
          value={comment}
          onChange = {handleCommentChange}
          data-testid="tagName"
          id="sushi-input"
          label="comment"
          key={"r"}
        />
      </NoFooterModal>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    cancel: bindActionCreators(OrderActions.cancel, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(CancelModal);
